module.exports = __webpack_public_path__ + "static/img/banner-qy.cfd8f87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/banner-qy.jpg
// module id = OY2w
// module chunks = 1